import type { ListingStatus } from './ListingStatus';

/**
 *
 */
export interface UpdateListingRequest {
  /**
   *
   */
  listingTypeId?: number;
  /**
   *
   */
  sellerId?: number;
  /**
   *
   */
  citySlugId?: number;
  /**
   *
   */
  postalCodeLat?: number;
  /**
   *
   */
  postalCodeLong?: number;
  /**
   *
   */
  description?: string;
  /**
   *
   */
  salePrice?: string;
  /**
   *
   */
  salePriceUnit?: string;
  /**
   *
   */
  negotiable?: boolean;
  /**
   *
   */
  transactionType?: UpdateListingRequestTransactionTypeEnum;
  /**
   *
   */
  ownershipType?: UpdateListingRequestOwnershipTypeEnum;
  /**
   *
   */
  facingDirection?: string | null;
  /**
   *
   */
  plotArea?: string;
  /**
   *
   */
  plotAreaUnit?: string;
  /**
   *
   */
  isActive?: boolean;
  /**
   *
   */
  isTopAdvert?: boolean;
  /**
   *
   */
  isFeaturedAdvert?: boolean;
  /**
   *
   */
  hasBoundaryWall?: boolean;
  /**
   *
   */
  approvedAuthority?: string | null;
  /**
   *
   */
  lengthOfPlot?: string | null;
  /**
   *
   */
  breathOfPlot?: string | null;
  /**
   *
   */
  soilType?: string | null;
  /**
   *
   */
  irrigationSource?: string | null;
  /**
   *
   */
  carpetArea?: string | null;
  /**
   *
   */
  carpetAreaUnit?: string | null;
  /**
   *
   */
  builtUpArea?: string | null;
  /**
   *
   */
  builtUpAreaUnit?: string | null;
  /**
   *
   */
  numOfBedrooms?: number | null;
  /**
   *
   */
  numOfBathrooms?: number | null;
  /**
   *
   */
  numOfBalconies?: number | null;
  /**
   *
   */
  floorCount?: number | null;
  /**
   *
   */
  parkingSpaces?: string | null;
  /**
   *
   */
  propertyAge?: number | null;
  /**
   *
   */
  videoIdList?: Array<string> | null;
  /**
   *
   */
  distanceToMainRoad?: number | null;
  /**
   *
   */
  distanceToSchool?: number | null;
  /**
   *
   */
  distanceToHospital?: number | null;
  /**
   *
   */
  areaOrLandmark?: string | null;
  /**
   * YouTube video ID to embed in the listing lightbox
   */
  youtubeVideoId?: string | null;
  /**
   * Instagram post or profile URL for this listing
   */
  instaUrl?: string | null;
  /**
   *
   */
  createDate?: ISODateTime;
  /**
   *
   */
  updateDate?: ISODateTime;
  /**
   *
   */
  listingStatus?: ListingStatus;
}

export enum UpdateListingRequestTransactionTypeEnum {
  NEW = 'new',
  RESALE = 'resale',
}
export enum UpdateListingRequestOwnershipTypeEnum {
  FREEHOLD = 'freehold',
  LEASEHOLD = 'leasehold',
  CO_OP = 'co-op',
}
